﻿import checkoutService from '../../api/checkout';
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
import { mapGetters, mapState } from 'vuex';

const cprCheck = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true;
    }
    //Will check if the dates in the CPR numbers are valid, and make sure dash(-) is only allowd at 7. posistion 
    var regExString =
        /^(?:(?:31(?:0[13578]|1[02])|(?:30|29)(?:0[13-9]|1[0-2])|(?:0[1-9]|1[0-9]|2[0-8])(?:0[1-9]|1[0-2]))[0-9]{2}-?[0-9]|290200-?[4-9]|2902(?:(?!00)[02468][048]|[13579][26])-?[0-3])[0-9]{3}$/;
    return regExString.test(value);
};

export default {
name: 'existing-customer',
    template: '#existing-customer-template',
    mounted() {
        this.$watch('$v.$invalid',
            () => {
                this.updateValidState();
            });
        this.updateValidState();
        this.$store.dispatch('existingCustomerBlockActive', true);
        if (this.viewmodel.cprNumber && this.viewmodel.cprNumber !== '') {
            this.cprNumber = this.viewmodel.cprNumber;
            this.selectedBan = this.viewmodel.ban;
            this.fetchUserInfo();
        }
    },
data: () => ({
    cprNumber: '',
    showBans: false,
    bans: [],
    selectedBan: '',
    customerDataFromCpr: {}
}),
    watch: {
    selectedBan: function(value) {

        for (var i = 0; i < this.bans.length; i++) {
            if (this.bans[i].accountId === value) {
                this.$store.dispatch('updateCustomer', this.bans[i].legalOwner.individual);
            }
        }
    }
    },
props: ['viewmodel', 'optionOne', 'optionTwo', 'addressMismatchText', 'redirectUrl'],
    computed:
Object.assign(
    mapState({
        customerDataValidated: state => state.checkout.customerDataValidated,
        installationAddress: state => state.checkout.basket.content.installationAddress
    }),
    {
    }
),
validations: {
    cprNumber: {
        required,
        cprCheck,
        maxLength: maxLength(10),
        minLength: minLength(10),
        numeric
    }
},
methods: {
    fetchUserInfo() {
        const parameters = { ssn: this.cprNumber, blockId: this.viewmodel.blockId };
        var ssnInputLength = this.cprNumber.length;
        if (ssnInputLength === 10) {
            checkoutService.saveInfo(this.viewmodel.getDebitorCustomerInformationAsyncUrl,
                parameters,
                (data) => {

                    //***** See Jira story XWIN-1931 for business rules *****//

                    //***** Security ****//

                    //Handle cpr check limit and NemId auth check
                    var modalOptions;
                    if (data.cprLookupLimitReached) {

                        //if(data.blockSalesAgent)
                        //{
                        //    modalOptions = [{ text: 'OK', action: 'post', url: this.viewmodel.signOutUrl }]
                        //}
                        //else
                        //{
                        //   modalOptions = [{ text: 'OK', action: 'redirect', url: this.redirectUrl }]
                        //}
                        modalOptions = [{ text: 'OK', action: 'redirect', url: this.redirectUrl }];
                        this.$store.dispatch('showAlert',
                            {
                                size: 'large',
                                header: '',
                                body: data.limitReachedMessage,
                                footer: '',
                                hideButton: false,
                                options: modalOptions
                            });
                    } else if (data.cprLookupFailed) {
                        modalOptions = [{ text: 'OK', action: 'reload' }];
                        this.$store.dispatch('showAlert',
                            {
                                size: 'large',
                                header: '',
                                body: data.cprLookupFailedMessage,
                                footer: '',
                                hideButton: false,
                                options: modalOptions
                            });
                    } else if (!data.nemIdAuthentication) {
                        modalOptions = [{ text: 'OK', action: 'reload' }];
                        this.$store.dispatch('showAlert',
                            {
                                size: 'large',
                                header: '',
                                body: data.nemIdCprFailed,
                                footer: '',
                                hideButton: false,
                                options: modalOptions
                            });
                    } else {
                        //***** Setup bans and add customer data ****//

                        //Data recieved from debitor register
                        this.customerDataFromCpr = data.response;
                        if (this.customerDataFromCpr.status !== 4) {
                            if (data.existingCustomer === true) {
                                this.updateBanList(data);

                                this.$store.dispatch('existingCustomer', true);
                            } else //New customer. 
                            {
                                this.showBans = false;

                                if (data.response.firstAndMiddleName != null) {
                                    //Send information from debitor cpr register to the customer vuex store.
                                    this.$store.dispatch('updateCustomerFromDebitorData', data.response);
                                    this.$store.dispatch('validateCustomerData', true);
                                }
                            }

                            //Installation address test
                            this.checkInstallationAddress();
                        }
                    }
                },
                () => {
                    //TODO handle failed lookup
                    console.log('cpr lookup failed');
                }
            );

        }
    },
    checkInstallationAddress() {
        if (this.customerDataFromCpr &&
            this.customerDataFromCpr.streetCode &&
            this.customerDataFromCpr.municipalityCode) {
            var installAddress = {
                streetName: this.installationAddress.streetName,
                houseNumber: this.installationAddress.streetNumber,
                floor: this.installationAddress.floorNumber,
                door: this.installationAddress.floorSide,
                zip: this.installationAddress.postCode,
                city: this.installationAddress.city
            };

            if (!this.addressMatchesCpr(installAddress)) {
                var modalOptions = [
                    { text: this.optionOne, header: '', body: 'test', action: '', url: '' },
                    { text: this.optionTwo, action: 'redirect', url: this.redirectUrl }
                ];
                this.$store.dispatch('showAlert',
                    {
                        size: 'large',
                        header: '',
                        body: this.addressMismatchText,
                        footer: '',
                        hideButton: false,
                        options: modalOptions
                    });
            }
        }
    },
    updateBanList(data) {
        this.bans.length = 0;
        var matchingAddressList = [];

        //Detect how many bans match the installation address
        for (var i = 0; i < data.accounts.length; i++) {
            var urbanAddress = data.accounts[i].legalOwner.individual.address.urbanAddress;
            var address = {
                streetName: urbanAddress.streetName,
                houseNumber: urbanAddress.streetNr,
                floor: urbanAddress.floorNumber,
                door: urbanAddress.doorNumber,
                zip: urbanAddress.postcode,
                city: urbanAddress.city
            };

            if (this.addressMatchesCpr(address)) {
                matchingAddressList.push(data.accounts[i]);
            }

            //Add all cusomer accounts to the bann list for future display
            this.bans.push(data.accounts[i]);
        }

        //If only one BAN matches the cpr address use that account for data population
        if (matchingAddressList.length === 1) {
            this.showBans = false; //We have found 1 exact match so don't show the other bans

            var ban = matchingAddressList[0].accountId;
            if(ban) {
                const parameters = { ban: ban };
                checkoutService.saveInfo(this.viewmodel.setBanUrl, parameters);
                    
            }                
            this.$store.dispatch('updateCustomer', matchingAddressList[0].legalOwner.individual);
        } else if (matchingAddressList.length > 1) //Multible bans on customer show the list of bans
        {
            this.bans.length = 0;
            this.bans = matchingAddressList.slice();
            this.showBans = true;
        } else //No BAN matches the cpr information. Ask customer to select a ban
        {
            this.showBans = true;
        }

        //Lock fields in personel details block
        this.$store.dispatch('validateCustomerData', true);
    },
    addressMatchesCpr(address) {
        var failed = false;
        if (!address || !this.customerDataFromCpr) failed = true;

        if (address.streetName &&
            this.customerDataFromCpr.streetName &&
            address.streetName !== this.customerDataFromCpr.streetName) {
            failed = true;
        }

        if (address.houseNumber &&
            this.customerDataFromCpr.houseNumber &&
            address.houseNumber !== this.customerDataFromCpr.houseNumber) {
            failed = true;
        }

        if (address.floor &&
            this.customerDataFromCpr.floor &&
            address.floor !== this.customerDataFromCpr.floor) {
            failed = true;
        }

        if (address.door &&
            this.customerDataFromCpr.door &&
            address.door.toLowerCase() !== this.customerDataFromCpr.door.toLowerCase()) {
            failed = true;
        }

        if (address.zip &&
            this.customerDataFromCpr.zip &&
            address.zip !== this.customerDataFromCpr.zip) {
            failed = true;
        }
        if (address.city &&
            this.customerDataFromCpr.city &&
            address.city !== this.customerDataFromCpr.city) {
            failed = true;
        }
        return !failed;
    },
    updateValidState() {
        this.$store.dispatch('updateValidState', { invalid: this.$v.$invalid, blockId: this.blockid });
    }
}
}